import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";

function ReviewCardVex({ card, preview, color, Textcolor, BtIColor,Iconcolor }) {
    const [cardData] = useContext(CardContext)
    const { review } = cardData
    const HColor = color ? color : 'black'

    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button, id) => {
        // console.log("iiii", id);

        updateTapCount(queryClient, button, id);
    };

    return (
        <>

            {review?.map((reviewData) =>
                reviewData.reviewName ? (
                    <Link
                        onClick={() => handleTap('reviews', reviewData._id)}
                        to={`${preview ? reviewData?.reviewUrl : ""}`}
                        target={`${preview ? "_blank" : ""}`}
                    >
                        {/* <div className="flex gap-3 mt-2 p-[16px] justify-between"> */}
                        {/* <div className="flex gap-3"> */}

                        <div className="flex justify-between mt-2 items-center gap-3">
                            <div className="flex justify-start items-center px-3 py-4 rounded-[8px] gap-2" style={{ background: `${Iconcolor ? Iconcolor : "black"}` }}>
                                <svg width="26" height="27" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.99914 20.4951L12.0008 17.3209L17.0024 20.5368L15.6925 14.5226L20.0987 10.5132L14.3031 9.97021L12.0008 4.29013L9.69845 9.92844L3.90288 10.4714L8.3091 14.5226L6.99914 20.4951ZM4.5777 24L6.54661 15.124L0 9.15662L8.62349 8.37143L12.0008 0L15.3781 8.36976L24 9.15495L17.4534 15.1224L19.4239 23.9983L12.0008 19.2872L4.5777 24Z" fill={BtIColor ? BtIColor : "black"} />
                                </svg>

                                <p className="text-[14px] font-normal text-left" style={{
                                    color: `${Textcolor ? Textcolor : ""}`,
                                }}>
                                    {reviewData?.reviewName ? reviewData.reviewName : "Review Name"}
                                </p>
                            </div>


                        </div>

                        {/* </div> */}

                        {/* </div> */}
                    </Link>
                ) : (
                    ""
                )
            )}

        </>
    );
}

export default ReviewCardVex;